import request from "../web-sh/src/utils/request";
import global from "../config/global";

async function get_enterprises_invitations(params = {}) {
  return request({
    url: global.endpoint.ENTERPRISE_MEMBERS_INVITATIONS,
    method: "get",
    params
  });
}

async function update_enterprises_invitation(invitationId, data = {}) {
  return request({
    url: global.endpoint.ENTERPRISE_MEMBERS_INVITATION.replace(':invitation_id', invitationId),
    method: "put",
    data
  });
}

async function get_master_password_requirement(enterpriseId) {
  return request({
    url: global.endpoint.ENTERPRISE_POLICY_MASTER_PASSWORD_REQUIREMENT.replace(':enterprise_id', enterpriseId),
    method: "get",
  });
}


export default {
  get_enterprises_invitations,
  update_enterprises_invitation,
  get_master_password_requirement
};
